module.exports = __webpack_public_path__ + "static/media/token-logo.3469f0ce.svg";